<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      skinData: '',
      isRouterAlive: true,
    };
  },
  created() {
    // this.getSkinType();
  },
  methods: {
    // 获取主题类型
    getSkinType() {
      let vm = this;
      let params = {
        callback: function (code, opt) {
          opt = typeof opt === 'object' ? opt : JSON.parse(opt);
          vm.skinData = Number(opt.ret) === 1 ? 'night' : '';
          sessionStorage.setItem('skinData', vm.skinData);
          vm.isRouterAlive = true;
        },
      };
      upNativeComm.exec('WebView.getThemeType', params);
    },
  },
};
</script>



// WEBPACK FOOTER //
// components/App.vue